import FileSaver from 'file-saver'
import { mapGetters } from 'vuex'
import { dateTimeBr } from '@/filters'
import { checkIdCard, checkTelPhone, checkEmail } from '@/utils/validator'

export default {
    install(Vue){
        Vue.mixin({
            data(){
                return {
                    anchorWorkType: {
                        0: {
                            name: '未设置'
                        },
                        1: {
                            name: '全职',
                            url: require('@/assets/full_time.png')
                        },
                        2: {
                            name: '兼职已签约',
                            url: require('@/assets/sign.png')
                        },
                        3: {
                            name: '兼职未签约',
                            url: require('@/assets/no_sign.png')
                        }
                    },
                    scheduleColors: {
                        0: {//未直播
                            weekStyle: {
                                backgroundColor: '#5166F6',
                                boxShadow: '0 0 10px 0 rgba(81, 102, 246, .5)',
                                color: '#fff'
                            },
                            monthStyle: {
                                borderColor: '#1890FF',
                                backgroundColor: 'rgba(24, 144, 255, .1)'
                            },
                            liveStatus: '未直播'
                        },
                        1: {//直播中
                            weekStyle: {
                                backgroundColor: '#FF6C6C',
                                boxShadow: '0 0 10px 0 rgba(253, 79, 106, .6)',
                                color: '#fff'
                            },
                            monthStyle: {
                                borderColor: '#ED4041',
                                backgroundColor: 'rgba(237, 64, 65, .1)'
                                // colorsMonth: [{
                                //     borderColor: '#ED4041',
                                //     backgroundColor: 'rgba(237, 64, 65, .1)'
                                // }, {
                                //     borderColor: '#1890FF',
                                //     backgroundColor: 'rgba(24, 144, 255, .1)'
                                // }, {
                                //     borderColor: '#5166F6',
                                //     backgroundColor: 'rgba(81, 102, 246, .1)'
                                // }]
                            },
                            liveStatus: '直播中...'
                            
                        },
                        2: {//直播结束
                            weekStyle: {
                                backgroundColor: '#ECECEC',
                                boxShadow: '0 0 10px 0 rgba(150, 150, 150, .3)',
                                color: '#000'
                            },
                            monthStyle: {
                                borderColor: '#5166F6',
                                backgroundColor: 'rgba(81, 102, 246, .1)'
                            },
                            liveStatus: '直播结束'
                        }
                    },
                    scheduleColorsStyle: {
                        3: {//排班未过期且未上播过（未直播）
                            weekStyle: {
                                backgroundColor: '#5166F6',
                                boxShadow: '0 0 10px 0 rgba(81, 102, 246, .5)',
                                color: '#fff'
                            },
                            monthStyle: {
                                // borderColor: '#5166F6',
                                borderColor: 'rgb(25, 168, 242)',
                                // backgroundColor: 'rgba(81, 102, 246, .1)'
                                // backgroundColor: '#727475'
                                // backgroundColor: 'rgba(25, 168, 242, .1)'
                                backgroundColor: 'rgba(255, 255, 255, .4)'
                            }
                        },
                        2: {//直播中
                            weekStyle: {
                                backgroundColor: '#FF6C6C',
                                boxShadow: '0 0 10px 0 rgba(253, 79, 106, .6)',
                                color: '#fff'
                            },
                            monthStyle: {
                                // borderColor: '#ED4041',
                                borderColor: 'rgb(40, 200, 64)',
                                // backgroundColor: 'rgba(237, 64, 65, .1)'
                                // backgroundColor: '#727475',
                                // backgroundColor: 'rgba(40, 200, 64, .1)'
                                backgroundColor: 'rgba(255, 255, 255, .4)'
                            }
                            
                        },
                        1: {//直播结束
                            weekStyle: {
                                backgroundColor: '#ECECEC',
                                boxShadow: '0 0 10px 0 rgba(150, 150, 150, .3)',
                                color: '#000'
                            },
                            monthStyle: {
                                // borderColor: '#1890FF',
                                borderColor: 'rgb(160, 160, 160)',
                                // backgroundColor: 'rgba(24, 144, 255, .1)'
                                // backgroundColor: '#727475',
                                // backgroundColor: 'rgba(160, 160, 160, .1)'
                                backgroundColor: 'rgba(255, 255, 255, .4)'
                            }
                        },//排班已过期且未上播过（未直播）
                        0: {
                            weekStyle: {
                                backgroundColor: '#F39800',
                                boxShadow: '0 0 10px 0 rgba(243, 152, 0, .3)',
                                color: '#fff'
                            },
                            monthStyle: {
                                // borderColor: '#F39800',
                                borderColor: 'rgb(255, 96, 88)',
                                // backgroundColor: 'rgba(243, 152, 0, .1)'
                                // backgroundColor: '#727475',
                                // backgroundColor: 'rgba(255, 96, 88, .1)'
                                backgroundColor: 'rgba(255, 255, 255, .4)'
                            }
                        }
                    },
                    defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
                    defaultShopLogo: require('@/assets/shop_logo_default.png')
                }
            },
            computed: {
                ...mapGetters(['userInfoDetail', 'btnPermissions']),
                Error(){
                    return Error
                },
                dateTimeBr(){
                    return dateTimeBr
                }
            },
            methods: {
                checkIdCard,
                checkTelPhone,
                checkEmail,
                searchListHandle(...searchList){
                    var searchQuery = {}
                    searchList.forEach(searchList => {
                        searchList.forEach(item => {
                            searchQuery[item.field_name] = (typeof(item.field_value) == 'object' && item.field_value != null) ? JSON.parse(JSON.stringify(item.field_value)) : item.field_value
                            if(item.field_type == 'radioAndCheckbox'){
                                let optItem = item.field_options.find(opt => opt.option_value === item.field_value)
                                if(optItem && optItem.search_list && optItem.search_list.length){
                                    searchQuery = {
                                        ...searchQuery,
                                        ...this.searchListHandle(optItem.search_list)
                                    }
                                }
                            }
                        })
                    })
                    return searchQuery
                },
                resetSearchList(searchList){
                    this.resetSearchListHandler(this[searchList])
                },
                resetSearchListHandler(searchList){
                    searchList.forEach(item => {
                        if(item.field_type == 'select'){
                            if(item.field_multiple){
                                item.field_value = []
                            }else{
                                item.field_value = -1
                            }
                        }else if(item.field_type == 'input'){
                            item.field_value = ''
                        }else if(item.field_type == 'cascader'){
                            item.field_value = []
                        }else if(item.field_type == 'dateTimeRange'){
                            item.field_value = []
                        }else if(item.field_type == 'dateRange'){
                            item.field_value = []
                        }else if(item.field_type == 'month'){
                            item.field_value = ''
                        }else if(item.field_type == 'monthRange'){
                            item.field_value = []
                        }else if(item.field_type == 'checkbox'){
                            item.field_value = []
                        }else if(item.field_type == 'radioAndCheckbox'){
                            item.field_value = ''
                            item.field_options.forEach(item => {
                                item.search_list && item.search_list.length && this.resetSearchListHandler(item.search_list)
                            })
                        }
                    })
                },
                revertSearchList(...searchList){
                    searchList.forEach(searchList => {
                        this.$refs[searchList] && this.$refs[searchList].forEach(vm => {
                            vm.revertValue()
                        })
                    })
                },
                multipleList(list, count){
                    var multi = []
                    for(var i=0; i<list.length; i+=count){
                        multi.push(list.slice(i, i + count))
                    }
                    return multi
                },
                refreshUserInfo(){
                    this.$store.dispatch('user/getUserInfo')
                },
                downloadFile(dir, name){
                    const loading = this.$loading({
                        lock: true,
                        text: '下载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.8)'
                    })
                    api.downloadFileByPath({
                        file_dir: dir,
                        file_name: name
                    }).then(result => {
                        FileSaver.saveAs(result, name)
                        loading.close();
                    })
                },
                showDownloadList(){
                    this.$store.commit('user/SET_DOWN_LIST_SHOW', true)
                    this.$store.commit('user/SET_DOWN_LIST_VISIBLE', true)
                },
                showAsyncTask(){
                    this.$store.commit('user/SET_ASYNC_TASK_SHOW', true)
                    this.$store.commit('user/SET_ASYNC_TASK_VISIBLE', true)
                },
                jumpErrorTip(elem){
                    setTimeout(() => {
                        let formItemError = elem.getElementsByClassName('el-form-item__error')
                        if(formItemError.length != 0){
                            formItemError[0].parentNode.parentNode.scrollIntoView()
                        }
                    }, 10)
                },
                previewImageHandle(list, index, field){
                    var previewPicturesList = []
                    for(var i=index; i<list.length; i++){
                        previewPicturesList.push(field ? list[i][field] : list[i])
                    }
                    for(var j=0; j<index; j++){
                        previewPicturesList.push(field ? list[j][field] : list[j])
                    }
                    return previewPicturesList
                },
                decimalSuffix(num){
                    return num.toString().includes('.') ? num.toString().substr(num.toString().lastIndexOf('.')) : ''
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/mixins/index.js